export {
  getMerchantLogo,
  getMerchantPrimaryColour,
} from './getBrandingDetails';
